export enum SelectSubjectType {
  NULL = null as any,
  ALL = "ALL" as any,
  NONE = "NONE" as any,
  SOME = "SOME" as any,
}
